module.exports = __webpack_public_path__ + "app/img/cardBG.41da499a.jpg";